@layer components {
  .badge {
    --sticker: var(--sticker-other);
    --tilt: -5deg;

    display: inline-grid;
    flex: none;
    place-items: center;
    inline-size: 2.625rem;
    block-size: 2.625rem;
    border-radius: var(--radius-sticker);
    background:
      var(--candy-gloss),
      linear-gradient(
        172deg,
        color-mix(in oklch, var(--sticker), white 22%),
        var(--sticker) 55%,
        color-mix(in oklch, var(--sticker), black 10%)
      );
    color: var(--sticker-ink);
    box-shadow:
      inset 0 -4px 6px -2px color-mix(in oklch, var(--sticker), black 22%),
      inset 0 2px 3px oklch(100% 0 0 / 55%),
      var(--shadow-candy-drop),
      0 1px 2px light-dark(oklch(25% 0.1 257 / 16%), oklch(0% 0 0 / 30%));
    font-family: var(--font-display);
    font-size: 0.6875rem;
    font-weight: 650;
    letter-spacing: 0.01em;
    rotate: var(--tilt);
    user-select: none;
    transition:
      rotate var(--duration-spring) var(--ease-spring),
      translate var(--duration-spring) var(--ease-spring),
      scale var(--duration-spring) var(--ease-spring);

    &[data-size="lg"] {
      inline-size: 4rem;
      block-size: 4rem;
      border-radius: var(--radius-sticker-lg);
      font-size: var(--text-base);
      box-shadow:
        inset 0 -6px 9px -3px color-mix(in oklch, var(--sticker), black 24%),
        inset 0 3px 4px oklch(100% 0 0 / 60%),
        0 12px 22px -8px oklch(15% 0.1 257 / 50%),
        0 2px 3px oklch(15% 0.1 257 / 22%);
    }

    &[data-kind="html"] {
      --sticker: var(--sticker-html);
      --tilt: -6deg;
    }

    &[data-kind="audio"] {
      --sticker: var(--sticker-audio);
      --tilt: 5deg;
    }

    &[data-kind="image"] {
      --sticker: var(--sticker-image);
      --tilt: -3deg;
    }

    &[data-kind="video"] {
      --sticker: var(--sticker-video);
      --tilt: 4deg;
    }

    &[data-kind="pdf"] {
      --sticker: var(--sticker-pdf);
      --tilt: -4deg;
    }

    &[data-kind="text"] {
      --sticker: var(--sticker-text);
      --tilt: 6deg;
    }

    &[data-kind="archive"] {
      --sticker: var(--sticker-archive);
      --tilt: -7deg;
    }

    &[data-kind="folder"] {
      --sticker: var(--sticker-folder);
      --tilt: 4deg;

      & svg {
        inline-size: 1.375rem;
        block-size: 1.375rem;
        stroke-width: 2.1;
      }

      &[data-size="lg"] svg {
        inline-size: 2rem;
        block-size: 2rem;
      }
    }
  }
}
